import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Grid } from "@mui/material";
import PrivacyPolicy from "./componets/PrivacyPolicy";
import HomePage from "./componets/HomePage";
import Categories from "./componets/Categories";
import Favourite from "./componets/Favourite.js";
import News from "./componets/News.js";
import TermsandConditions from "./componets/TermsandConditions.js";
import Internship from "./componets/Internship.js";
import AboutUs from "./componets/AboutUs.js";
import LandingPage from './componets/LandingPage.js'

const App = () => {
  return (
    <Router>
      <Grid>
        <Routes>
          {/* Home Page Route */}
          <Route path="/" element={<HomePage />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/favourite" element={<Favourite />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/news" element={<News />} />
          <Route path="/internship" element={<Internship />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsandConditions />} />
          <Route path="/download" element={<LandingPage />} />
        </Routes>
      </Grid>
    </Router>
  );
};

export default App;

